import * as Yup from 'yup';

const signInValidation = Yup.object({
  emailAddress: Yup.string()
    .email('Enter a valid email address')
    .required('Email address is required'),
  password: Yup.string()
    .required('Password is required')
});

export default signInValidation;
